(() => {
  const initialize = (root) => root.querySelectorAll('[data-becoming-gallery]').forEach((gallery) => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const wall = gallery.querySelector('[data-gallery-wall]');
    const status = gallery.querySelector('[data-gallery-status]');
    const more = gallery.querySelector('[data-gallery-more]');
    const retry = gallery.querySelector('[data-gallery-retry]');
    const viewer = gallery.querySelector('[data-gallery-viewer]');
    const large = gallery.querySelector('[data-gallery-large]');
    const position = gallery.querySelector('[data-gallery-position]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    let photos = [], shown = 0, active = 0, opener;
    const nearbyImages = new Map();
    const imageUrl = (url, width) => {
      const parsed = new URL(url, window.location.href);
      if (parsed.hostname === 'cdn.shopify.com') parsed.searchParams.set('width', width);
      return parsed.href;
    };
    const viewerUrl = (photo) => {
      const pixels = (window.innerWidth || 1600) * Math.min(window.devicePixelRatio || 1, 2);
      const width = [960, 1280, 1600].find((size) => size >= pixels) || 1600;
      return imageUrl(photo.url, width);
    };
    const preloadNearby = () => {
      const nearby = new Set();
      for (const index of [active - 1, active, active + 1, active + 2]) {
        if (!photos[index]) continue;
        const url = viewerUrl(photos[index]);
        nearby.add(url);
        if (index === active || nearbyImages.has(url)) continue;
        const image = new Image();
        image.decoding = 'async'; image.src = url;
        nearbyImages.set(url, image);
      }
      for (const url of nearbyImages.keys()) if (!nearby.has(url)) nearbyImages.delete(url);
    };
    const updateViewer = () => {
      const photo = photos[active];
      delete large.dataset.loaded;
      large.src = viewerUrl(photo); large.alt = photo.alt || `Becoming event photograph ${active + 1}`;
      large.width = photo.width; large.height = photo.height;
      position.textContent = `${active + 1} / ${photos.length}`;
      previous.disabled = active === 0; next.disabled = active === photos.length - 1;
      preloadNearby();
    };
    large.addEventListener('load', () => { large.dataset.loaded = 'true'; });
    wall.addEventListener('click', (event) => {
      const link = event.target.closest('[data-gallery-photo]');
      if (!link || typeof viewer.showModal !== 'function' || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const index = Number(link.dataset.galleryIndex);
      if (!Number.isInteger(index) || !photos[index]) return;
      event.preventDefault(); active = index; opener = link; updateViewer(); viewer.showModal();
    });
    previous.addEventListener('click', () => { if (active > 0) { active--; updateViewer(); } });
    next.addEventListener('click', () => { if (active < photos.length - 1) { active++; updateViewer(); } });
    viewer.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); (event.key === 'ArrowLeft' ? previous : next).click();
      }
    });
    viewer.addEventListener('close', () => { large.removeAttribute('src'); nearbyImages.clear(); opener?.focus({ preventScroll: true }); });
    const appendBatch = () => {
      const start = shown, fragment = document.createDocumentFragment();
      const scrollLeft = window.scrollX, scrollTop = window.scrollY;
      photos.slice(start, start + 24).forEach((photo, offset) => {
        const index = start + offset, link = document.createElement('a'), img = document.createElement('img');
        link.className = start > 0 ? 'bg-photo bg-photo-added' : 'bg-photo'; link.href = imageUrl(photo.url, 1600);
        link.dataset.galleryPhoto = ''; link.dataset.galleryIndex = String(index);
        link.setAttribute('aria-label', `Open photograph ${index + 1} of ${photos.length}`);
        img.src = imageUrl(photo.url, 720);
        img.srcset = [320, 480, 720, 960].map((width) => `${imageUrl(photo.url, width)} ${width}w`).join(', ');
        img.sizes = '(min-width: 1200px) 25vw, (min-width: 700px) 33vw, 50vw';
        img.width = photo.width; img.height = photo.height; img.alt = photo.alt || `Becoming event photograph ${index + 1}`;
        img.loading = index < 2 ? 'eager' : 'lazy'; img.decoding = 'async';
        link.append(img); fragment.append(link);
      });
      if (start === 0) wall.replaceChildren(fragment); else wall.append(fragment);
      shown = Math.min(start + 24, photos.length); more.hidden = shown >= photos.length;
      status.textContent = `${shown} of ${photos.length} photographs`;
      if (start > 0) {
        wall.querySelector(`[data-gallery-index="${start}"]`)?.focus({ preventScroll: true });
        window.scrollTo({ left: scrollLeft, top: scrollTop, behavior: 'instant' });
      }
    };
    const load = async () => {
      retry.hidden = true; status.textContent = 'Loading photographs…';
      try {
        const response = await fetch(gallery.dataset.manifestUrl, { signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Gallery unavailable');
        const data = await response.json();
        if (data.version !== 1 || !Array.isArray(data.photos)) throw new Error('Invalid gallery');
        photos = data.photos.filter((photo) => {
          try {
            const url = new URL(photo.url, window.location.href);
            const localPreview = gallery.dataset.preview === 'true' && url.origin === window.location.origin;
            return ((url.protocol === 'https:' && url.hostname === 'cdn.shopify.com') || localPreview) &&
              Number.isInteger(photo.width) && photo.width > 0 && Number.isInteger(photo.height) && photo.height > 0;
          } catch { return false; }
        });
        if (!photos.length) { status.textContent = wall.children.length ? 'Selected moments from Becoming. More photographs will be added soon.' : 'Photographs will be added soon.'; return; }
        shown = 0; appendBatch();
      } catch {
        status.textContent = 'We couldn’t load the complete gallery. Please try again.'; retry.hidden = false;
      }
    };
    more.addEventListener('click', appendBatch); retry.addEventListener('click', load); load();
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
